import React from 'react';
import { datasetUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const DatasetAction = ({ code, disabled }) => (
  <RibbonMenu
    name="dataset"
    icon="table"
    message="tabs.dataset"
    url={datasetUrl({ code }, '#')}
    className="aridhia-dataset-action"
    disabled={disabled}
  />
);

export default DatasetAction;
